/**
 * 全域配色系統
 * 與 Notice 組件保持一致的配色方案
 */

export const colors = {
  // Primary variant - 紫色系（主題色）
  primary: {
    background: '#f5f3ff',
    border: '#c4b5fd',
    text: '#6366f1',
    main: '#6366f1',
  },

  // Secondary variant - 綠色系（輔助色）
  secondary: {
    background: '#ecfdf5',
    border: '#6ee7b7',
    text: '#10b981',
    main: '#10b981',
  },

  // Info variant - 藍色系
  info: {
    background: '#f0f8ff',
    border: '#91c5ff',
    text: '#0958d9',
  },
  
  // Warning variant - 黃色系
  warning: {
    background: '#fff7e6',
    border: '#ffd591',
    text: '#d48806',
  },
  
  // Success variant - 綠色系
  success: {
    background: '#f6ffed',
    border: '#b7eb8f',
    text: '#389e0d',
  },
  
  // Error variant - 紅色系
  error: {
    background: '#fff2f0',
    border: '#ffccc7',
    text: '#cf1322',
  },
};

export default colors;
